export default __webpack_public_path__ + "static/media/N2P_1851.a8188c5d.jpg";